module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "tag-container",
    class: {
      'tag-container--small': _vm.size === 'small'
    }
  }, _vm._l((_vm.tags), function(tag, index) {
    return _c('span', {
      staticClass: "tag",
      class: tag.tag
    }, [_vm._v(_vm._s(tag.name))])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4855eba5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/article/tags.vue
// module id = 55
// module chunks = 4 5